<template>
  <div class="d-flex flex-column flex-column-fluid flex-lg-row">
    <div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
      <div class="d-flex flex-center flex-lg-start flex-column text-start">
        <a href="/" class="mb-7">
          <img :alt="$t('logo')" src="assets/theme/media/logos/logo-cc-white.png">
        </a>
        <h2 class="text-white fw-normal m-0 ms-4"> {{ $t('branding_tools_designed_for') }} </h2>
      </div>
    </div>
    <div class="d-flex flex-center w-lg-50 p-10">
      <div class="card rounded-3 w-md-550px pt-15 pb-15 mt-20 bgi-no-repeat bgi-position-y-top bgi-position-x-end shadow bg-abstract-4">
        <div v-if="!isSendResetLink" class="card-body p-20 p-lg-20">
          <form class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework fw-row" v-if="!isSendResetLink" @submit.prevent="onBeforeSubmit()">
            <div class="text-center mb-10">
                <h1 class="fw-bolder mb-3">
                     {{ $t('forgot_password') }} 
                </h1>
                <div class="text-gray-500 fw-semibold fs-6">
                     {{ $t('enter_your_e-mail_address') }} 
                </div>
            </div>
            <div class="fv-row mb-8 fv-plugins-icon-container">
              <input type="text" :placeholder="$t('email')" name="email" autocomplete="off" class="form-control bg-white" v-model="form.user_mail" :class="{'border border-danger': isValidEmail == false}"> 
              <small class="text-danger" v-if="!isValidEmail && form.user_mail !== null && form.user_mail !== '' "> {{ $t('email_is_not_valid') }} </small>
            </div>

            <div class="d-flex flex-wrap justify-content-center pb-lg-0">
              <button @click="onBeforeSubmit()" type="button" class="btn btn-primary me-4" data-kt-indicator="on" :disabled="isValidEmail !== true">                      
                <span v-if="!this.isProgressing">  {{ $t('reset_password') }}  </span>
                <span class="indicator-progress" v-if="this.isProgressing">
                   {{ $t('please_wait') }}     <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              </button>
              <router-link to="/Login">
                <a href="#" class="btn btn-light">
                     {{ $t('cancel') }} 
                </a>
              </router-link>
            </div>
          </form>
        </div>
        
        <div v-if="isSendResetLink" class="card-body p-20 p-lg-20 text-center">
          <h1 class="fw-bolder text-gray-800 mb-5">
             {{ $t('reset_link_has_been') }} 
          </h1>
          <div class="fs-6 mb-5">
            <span class="fw-semibold text-gray-500 mb-5"> {{ $t('to_set_your_new') }} </span>
          </div>
          <div class="mb-11">
            <img src="/assets/theme/media/illustrations/unitedpalms-1/16.png" class="mw-100 mh-200px theme-light-show" alt="">
            <img src="/assets/theme/media/illustrations/unitedpalms-1/16-dark.png" class="mw-100 mh-200px theme-dark-show" alt="">
          </div>
          <div class="fs-6 mb-5">
            <span class="fw-semibold text-gray-500 me-1"> {{ $t('didnt_receive_an_email') }} </span>

            <a href="#" class="link-primary fw-bold" @click="onTryAgain()">  {{ $t('try_again') }} </a>
          </div>
          <div class="mb-0">
            <router-link to="/Login">
              <button type="button" class="btn btn-sm btn-primary">
                 {{ $t('back_to_login') }} 
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { load } from 'recaptcha-v3';

export default {
  name: "ForgotPassword",
  data() {
    return {
      form: {
        user_mail: ''
      },
      isSendResetLink: false,
      isProgressing: false,
      isVerifyRecaptcha: false,
      rc_sk: ''
    };
  },
  computed: {
    isValidEmail() {
      return (this.form.user_mail == null || this.form.user_mail == '' || this.form.user_mail == undefined) ? null : /^[^@]+@\w+(\.\w+)+\w$/.test(this.form.user_mail);
    }
  },
  methods: {
    getData(){
      document.body.style.backgroundImage = "url('/assets/theme/media/auth/bg7-dark.jpg')";
      document.body.classList.add('app-blank');
      document.body.classList.add('bgi-size-cover');
      document.body.classList.add('bgi-position-center');
      document.body.classList.add('bgi-no-repeat');

      axios.get('/api/GeneralUserParameters/GetRc').then((response) => {
          if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
            this.isVerifyRecaptcha = response.data.is_view_rc_fp == 1 ? true : false;
            this.rc_sk = this.$unlock(response.data.sk);
            this.loadReCaptcha();
          }
      })
      .catch((error) => {
        console.error(error);
      });
    },
    async loadReCaptcha() {
			if(this.rc_sk !== null && this.rc_sk !== '' && this.rc_sk !== undefined) {
        const recaptcha = await load(this.rc_sk);
        if(!this.isVerifyRecaptcha) recaptcha.hideBadge();
        else recaptcha.showBadge();
      }
    },
    async onBeforeSubmit() {
      if(this.isVerifyRecaptcha) {
        const recaptcha = await load(this.rc_sk);
        const token = await recaptcha.execute('login');
        this.sendResetLink(token, true);
      } else {
        this.sendResetLink();
      }
    },
    sendResetLink(token, is_recaptcha_active) {
      if(!this.form.user_mail) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('email_address_is_required')
        })
      } else {
        this.isProgressing = true;
        const parameters = {
          user_mail: this.form.user_mail,
          tk: token,
          ira: is_recaptcha_active,
          lang: localStorage.getItem('locale') || this.$i18n.locale || 'en'
        };  
        const that = this; 
        axios.post('/api/Auth/SendResetLink', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
          if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
            this.isSendResetLink = true;
          }
        })
        .catch(function() {
          new Swal( { icon: 'error', title: 'Error...', text: this.$t('mail_server_not_defined_or_invalid') });
        })
        .finally(() => { 
          setTimeout(() => {
            that.isProgressing = false;
          }, 500);
        }); 
      }
    },
    onTryAgain() {
      this.form.user_mail = null;
      this.isSendResetLink = false;
    }
  },
  created() {
     this.getData();
  }
};
</script>